import { api } from './api';
import { Log } from '../types/api.types';

export const logsApi = {
    getAll: (): Promise<Log[]> =>
        api.get('/admin/logs').then(res => res.data),

    create: (data: Partial<Log>): Promise<Log> =>
        api.post('/admin/logs', data).then(res => res.data),
};